var render = function render() {
  var _vm$label;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    class: _vm.className,
    attrs: {
      id: "navigation"
    },
    on: {
      click: _vm.backToList
    }
  }, [_c("i", {
    staticClass: "fas fa-long-arrow-alt-left",
    attrs: {
      title: "Back"
    }
  }), _vm._v(" " + _vm._s((_vm$label = _vm.label) !== null && _vm$label !== void 0 ? _vm$label : "Previous page") + " ")]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };